export function NonBreakingSpace(props) {
  return (
    <>
      {" ".replace(" ", "\u00a0")}
    </>
  )
}

export default NonBreakingSpace;